// this file was autogenerated by reading the translations-csv files, please do not touch and refer to the csv 
export default {
  "lang-de": "Tedesco",
  "lang-ne": "Olandese",
  "lang-en": "Inglese",
  "lang-es": "Spagnolo",
  "lang-fr": "Francese",
  "lang-ar": "Arabo",
  "lang-it": "Italiano",
  "lang-be": "Portoghese",
  "label.username": "Utente",
  "label.password": "Password",
  "label.confirmpassword": "Conferma Password",
  "label.firstName": "Nome",
  "label.lastName": "Cognome",
  "label.language": "Lingua",
  "label.my-submissions": "Le mie richieste",
  "label.my-profile": "Il mio profilo",
  "label.description": "Descrizione",
  "label.aboutyou": "Raccontaci di te",
  "label.tasks-description": "Attività",
  "label.requirements-description": "Requisiti",
  "label.benefits-description": "Prestazioni",
  "label.skills-required": "Competenze richieste",
  "label.additional-information": "Ulteriori informazioni",
  "label.desirable-skills": "Abilità desiderate",
  "label.responsability-level": "Livello di responsabilità",
  "label.min-salary": "Stipendio minimo",
  "label.max-salary": "Stipendio massimo",
  "label.no-additional-skills-needed": "Competenze aggiuntive non richieste",
  "label.required-experience": "Esperienza richiesta",
  "label.salary-expectations": "",
  "label.name": "Nome",
  "label.middle-name": "Secondo nome",
  "label.surname": "Cognome",
  "label.level": "Livello",
  "label.applicants": "Candidati",
  "label.location": "Città di residenza",
  "label.workplace": "Sede di lavoro",
  "label.area": "Area",
  "label.residence": "Residenza",
  "label.residencecity": "Città di residenza",
  "label.cityaddress": "Città di domicilio",
  "label.address": "Domicilio",
  "label.timetable": "Orario",
  "label.country": "Nazione",
  "label.sort": "Ordine",
  "label.ascendant": "Ascendente",
  "label.descendant": "Discendente",
  "label.salary-gross": "Lordo annuo",
  "label.job-experiences": "Esperienze lavorative",
  "label.azienda": "Azienda",
  "label.my-skills": "Le mie competenze",
  "label.education": "Istruzione: ultimo titolo di studio conseguito",
  "label.my-job-requests": "Le mie richieste di lavoro",
  "label.similar-jobs": "Lavori similari",
  "label.add-image": "Aggiungi immagine",
  "label.company": "Nome azienda",
  "label.sector": "Settore",
  "label.period": "Periodo",
  "label.edit-profile": "Modifica profilo",
  "label.phone": "Numero di telefono",
  "label.interesse": "Aree di interesse",
  "label.date-of-birth": "Data di nascita",
  "label.start-date": "Data di inizio",
  "label.end-date": "Data di fine",
  "label.email": "Email",
  "label.second-type": "Secondo tipo",
  "label.state": "Stato",
  "label.domain": "Dominio",
  "label.guest": "Login",
  "label.degree": "Livello di istruzione",
  "label.major-domain-area": "Area disciplinare",
  "label.minor-domain-area": "Seconda area",
  "label.all-rights-reserved": "Tutti i diritti riservati.",
  "label.operation-success": "Successo dell'operazione",
  "label.del-candidatura-success": "Candidatura eliminata con successo",
  "label.candidatura-success": "Candidatura inviata con successo",
  "note.privacy-policy": "Dichiaro di aver letto e compreso",
  "note.privacyPol": "Ho preso visione dell’{param} ai sensi dell’Art. 13 del GDPR",
  "note.second-privacy-policy": "Fornisco il mio consenso al trattamento delle categorie particolari di dati personali eventualmente contenuti nel mio Curriculum Vitae (ad es. appartenenza a categorie protette)",
  "label.privacy-policy": "Politica sulla riservatezza",
  "label.registration-success": "È stata inviata un'e-mail all'indirizzo fornito per confermare la registrazione",
  "label.reset-success": "È stata inviata un'e-mail all'indirizzo fornito per confermare la nuova password",
  "label.male": "Maschile",
  "label.female": "Femminile",
  "label.gender": "Genere",
  "label.informativa-privacy": "Informativa sulla privacy",
  "label.current-job": "lavoro attuale",
  "label.reset-password": "Ha dimenticato la password?",
  "label.present": "Presente",
  "label.salary-aspettative": "Aspettativa di stipendio",
  "label.responsability": "Ruolo ricoperto",
  "label.job-experience": "Esperienze lavorative",
  "label.school": "Istituto",
  "label.profilecompleted": "Profilo completo",
  "label.profileincompleted": "Profilo incompleto",
  "label.cantapplied": "Completa il tuo profilo per inviare la tua candidatura",
  "label.first-job": "Sono alla ricerca del mio primo lavoro",
  "label.explore-jobs": "Posizioni aperte"
};